const AuthStep = {
  FORM_SCREEN: 1,
  TWO_FA_SCREEN: 2,
  MFA_SCREEN: 3,
  CONFIRMATION_MSG_SCREEN: 4,
  ERROR_MSG_SCREEN: 5,
};
export default AuthStep;
